import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="bg-brand-charcoal text-gray-400 py-12 px-4 text-center text-sm" data-id="element-82">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-83">
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-8" data-id="element-84">
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-85">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-86">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-87">
            Contacto
          </a>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-88">
            Política de Reembolsos
          </a>
        </div>

        <p data-id="element-89">
          Descargo de responsabilidad: Los resultados pueden variar. Esta guía
          está diseñada con fines educativos y de desarrollo personal. No
          reemplaza la terapia psicológica profesional.
        </p>

        <p className="pt-4 border-t border-gray-800" data-id="element-90">
          © 2026 La Guía Definitiva — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
};